export default __webpack_public_path__ + "static/media/Lock.a306eaf0.svg";